import { injectGlobal } from "styled-components"
import * as vars from "../style/vars"
import { above, below, fontFace } from "../style/functions"
import circleArrow from "../svg/right-circle.svg"
import circleArrowWhite from "../svg/right-circle-white.svg"

injectGlobal`
	* {
		box-sizing: border-box;
	}

	img{
		max-width: 100%;
	}

	strong{
		font-weight: bold;
	}

	body {
		overflow-x: hidden;
	}
/*
	html, body {
		width: 1366px;
		height:768px;
		margin: auto;
	}
	html{
		background-image: url('/images/feb-19-updates/bg.jpg');
	}
	body {
		opacity: 0.8;
	}
*/
 #wrapper{
	${below.tablet`
	padding-top: 8.8rem!important;
	`};
	${below.mobile`
	padding-top: 4.7rem!important;
	`};
 }
	h1, .h1{
		font-family: ${vars.fonts.feature};
		font-weight: normal;
		font-size:13.6rem;
		line-height: 11.6rem;
		letter-spacing: -2px;
		padding-bottom: ${vars.padding.inner}rem;
		&.large{
			font-size: 23.8rem;
			${below.xl`
				font-size: 17rem;
			`}
			${below.tablet`
			font-size: 10rem;
		`}

		${below.mobile`
			font-size: 7rem;
		`}
		}
		&.small{
			font-size: 11rem;
			${below.desktop`
			font-size: 10rem;
		`}
		${below.tablet`
			font-size: 6rem;
			padding-bottom: ${(vars.padding.inner)}rem;
		`}
		${below.mobile`
			font-size: 4rem;
			padding-bottom: ${(vars.padding.mobInner)}rem;

		`}
		${below.xs`
			font-size: 3rem;
		`}
		}
		${below.giant`
		font-size: 11.7rem;
		line-height:10.5rem;
		`}
		${below.mid`
			font-size: 11rem;
			line-height: 10rem;
		`}
		${below.desktop`
			font-size: 10rem;
			line-height: 9rem;
		`}
		${below.tablet`
			font-size: 8rem;
			padding-bottom: ${(vars.padding.inner)}rem;
			line-height: 1.1;
		`}
		${below.mobile`
			font-size: 4rem;
		`}
		${below.xs`
			font-size: 3rem;
		`}
	}
	h2{
		font-family: ${vars.fonts.feature};
		font-weight: normal;
		font-size:5.7rem;
		padding-bottom: ${(vars.padding.inner / 2)}rem;
		${below.tablet`
			font-size:4rem;
		`}
		${below.mobile`
			font-size:2.6rem;
		`}
	}
	h3, .h3{
		font-family: ${vars.fonts.feature};
		font-weight: normal;
		font-size:3.6rem;
		padding-bottom: ${vars.padding.inner}rem;
		${below.tablet`
			font-size:2.8rem;
		`}
		${below.mobile`
			font-size:1.9rem;
			padding-bottom: ${(vars.padding.inner / 2)}rem;

		`}
	}
	h4{
		font-size:2.7rem;
		font-weight: bold;
		padding-bottom: ${(vars.padding.inner * 2)}rem;
		${below.tablet`
			font-size:2.3rem;
		`}
		${below.mobile`
			font-size:2rem;
		`}
	}

	p{
		font-size:1.6rem;
		line-height:2.1rem;
		letter-spacing: .8px;
		padding-bottom: ${(vars.padding.inner / 2)}rem;
		${below.mid`
			font-size:1.5rem;
		`}
		${below.tablet`
			font-size:1.7rem;
		`}
		${below.mobile`
			font-size:1.4rem;
		`}
		${below.xs`
			font-size:1.3rem;
		`}
		&.large {
			font-size: 2rem;
			padding-bottom: ${vars.padding.inner / 2}rem;
		}
		a {
			text-decoration: none;
			border-bottom: 2px solid currentcolor;
			&:not(.link-email):after {
				content: url('/svg/arrow.svg');
				width: 1.8rem;
				height:0.8rem;
				display: inline-block;
				margin-left: 0.4rem;
			}
		}
	}

	a{
		color: inherit;
	}

	.bg {
		position: relative;
		&:after {
			content: '';
			height: 50%;
			width: 100%;
			position: absolute;
			bottom: -50%;
		}
		&.mini:after{
			height: 20%;
			bottom: -20%;
		}
		&.none{
			margin-bottom: ${vars.padding.inner * 2}rem;
			&:after{
				display:none;
			}
		}
		&.light, &.light:after{
			background: ${vars.colors.offColor};
		}
		&.dark, &.dark:after{
			background: ${vars.colors.body};
			color: ${vars.colors.blank};
		}
		&.dark div {
			border-color: ${vars.colors.blank} !important;
		}
		&.custom, &.custom:after{
			background: currentcolor;
		}
		&.custom div{
				border-color: ${vars.colors.blank} !important;
				color: ${vars.colors.blank};

			}
		}
	}

	div[data-oembed-type="video"]{
		> div{
			width:100%;
			height:0;
			padding-bottom:56.25%;
			position:relative;

			iframe{
				position: absolute;
				padding-bottom:0;
				min-height:0;
				width:100%;
				height:100%;
			}
		}
		margin-bottom:1rem;
	}

	pre, code{
			padding: ${vars.padding.inner / 2}rem;
			background: ${vars.colors.offColor};
			font-family: Courier New;
	}

	ul, ol {
		max-width: 60rem;
		margin-left: 1.5em;
		font-size:1.6rem;
		padding-bottom: ${(vars.padding.inner / 2)}rem;
		${below.tablet`
			font-size:1.7rem;
		`}
		${below.mobile`
			font-size:1.8rem;
		`}
		li{
			padding-bottom: ${(vars.padding.inner / 3)}rem;
		}
	}
	/* ul, ul li{
		list-style-type: square;
	} */
	ol, ol li{
		list-style: decimal;
	}
	.btn {
		display:block;
		font-weight: normal;
		&.btn-more {
			font-size: 1.4rem;
			line-height: 1;
			text-decoration: underline;
			color: ${vars.colors.body};
			text-align:center;
			width:100%;
			padding: 1.2rem;
			border-top: 1px solid ${vars.colors.offColor};
			border-bottom: 1px solid ${vars.colors.offColor};
			transition: ${vars.time}s background ease-in-out;
			&:hover {
				background: ${vars.colors.offColor};
			}
		}
		&.btn-arrow {
			position: relative;
         left: -5px;
         font-size: 1.4rem;
			&:before {
				content: '';
				display: inline-block;
				width: 3rem;
				height: 3rem;
				background: url(${circleArrow});
				vertical-align: middle;
				left: 0;
				top: 1px;
				position: relative;
				margin-right: 8px;
				${below.mobile`
					width: 1.5rem;
					height: 1.5rem;
				`}
			}
			&.white {
				&:before {
					background: url(${circleArrowWhite});
				}
			}
		}

		&.btn-square {
         white-space: nowrap;
         display: inline-block;
			position: relative;
         background: ${vars.colors.body};
         color: ${vars.colors.blank};
         padding: 1.2rem 1.75rem;
         cursor: pointer;
			text-decoration: none;
			${below.mobile`
			padding: 1rem 1.5rem;
				`}

			&.white {
				background: ${vars.colors.blank};
				color: ${vars.colors.body};
			}

			&.transparent {
				background: transparent;
				color: ${vars.colors.blank};
				padding-left: 0;
			}

			&:after {
				content: ' →';
				margin-left: .5rem;
				transition: margin-left .5s;
				font-size: 13px;
				text-decoration: none;
			}

         &:hover:after {
				margin-left: .9rem;
         }

			span {
				text-decoration: underline;
				font-size: 1.5rem;
				font-weight: lighter;
				${below.mobile`
					font-size: 1.3rem;
				`}
			}
		}
	}

	iframe, embed {
		width: 100%;
		padding-bottom: ${vars.padding.inner}rem;
		min-height: 60rem;
	}

	svg{
		fill: currentcolor;
	}
	.enquire{
		${below.mobile`
			#footer_enquire{
				display:none;
			}
		`}
	}

	.clearfix:after {
		content: "";
		display: table;
		clear: both;
	}

	.la--n{
		text-decoration:none!important;
		border-bottom:none!important;
		&:after{
			display:none!important;
		}
	}
`



// WEBPACK FOOTER //
// ./src/style/main.js